import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { OrderMedicationItem, OrderMedicationsResponse, OrderMedicationsState } from "./index.types";

export const initialOrderMedicationsState: OrderMedicationsState = {
  orderMedicationsList: [],
  orderMedicationsIsLoading: false,
  specificOrderMedication: {} as OrderMedicationItem,
};

const name = "orderMedications";

export const orderMedicationsSlice = createSlice({
  name,
  initialState: initialOrderMedicationsState,
  reducers: {
    getOrderMedications: (state) => {
      state.orderMedicationsIsLoading = true;
    },
    getMedicationById: (state, action: PayloadAction<string | number>) => {
      const id = action.payload;
      state.specificOrderMedication =
        state.orderMedicationsList.find(({ medicine_id, id: prescriptionId }) => medicine_id === id || prescriptionId === id) ||
        ({} as OrderMedicationItem);
    },
    getOrderMedicationsSuccess: (state, action: PayloadAction<OrderMedicationsResponse>) => {
      state.orderMedicationsIsLoading = false;
      state.orderMedicationsList = action.payload?.results || [];
    },
    getOrderMedicationsFail: (state) => {
      state.orderMedicationsList = [];
      state.orderMedicationsIsLoading = false;
    },
    clearOrderMedicationsData: (state) => {
      state.orderMedicationsIsLoading = false;
      state.specificOrderMedication = {} as OrderMedicationItem;
    },
    clearAllOrderMedicationsStates: (state) => {
      state.orderMedicationsIsLoading = false;
      state.specificOrderMedication = {} as OrderMedicationItem;
      state.orderMedicationsList = [];
    },
  },
});

export const { getOrderMedications, clearOrderMedicationsData, clearAllOrderMedicationsStates, getMedicationById } =
  orderMedicationsSlice.actions;

export default orderMedicationsSlice.reducer;

export const getOrderMedicationsList = (patientId: string | number, encounterId: string | number) => ({
  payload: {
    apiName: name,
    method: "get",
    url: `/api/patients/${patientId}/prescriptions/?encounter_pk=${encounterId}`,
  },
  type: "getOrderMedications",
});
